import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  /* plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    })
  ], */
  state: {
    showContectUs: false,
    lang: 'en',
  },
  mutations: {
    flip(state) {
      state.showContectUs = !state.showContectUs
    },
    changeLang(state,what ) {
      state.lang = what
    }
  },
  actions: {
  },
  modules: {
  }
})
